import type { IntegrationStatus } from '@/api/hooks/useOrders'
import {
  FiltersPopover,
  SectionLabel,
} from '@/components/Display/FiltersPopover'
import { Vertical } from '@gravitate-js/excalibrr'
import { Select } from 'antd'
import { useState } from 'react'
import {
  EMPTY_ORDER_FILTERS,
  INTEGRATION_STATUS_OPTIONS,
  type OrderFilters,
  type OrderProgressionState,
  PROGRESSION_STATE_OPTIONS,
  type PartnerOption,
  activeFilterCount,
} from '../ordersFilterModel'

const CONTENT_WIDTH = 320

export function OrdersFilterPopover({
  value,
  onChange,
  partnerOptions,
}: {
  value: OrderFilters
  onChange: (filters: OrderFilters) => void
  partnerOptions: PartnerOption[]
}) {
  const [open, setOpen] = useState(false)
  const [draft, setDraft] = useState(value)

  const handleOpenChange = (next: boolean) => {
    if (next) setDraft(value)
    else onChange(draft)
    setOpen(next)
  }

  return (
    <FiltersPopover
      width={CONTENT_WIDTH}
      activeCount={activeFilterCount(value)}
      open={open}
      onOpenChange={handleOpenChange}
      onClear={() => setDraft(EMPTY_ORDER_FILTERS)}
    >
      <Vertical gap={4}>
        <SectionLabel>Integration Status</SectionLabel>
        <Select
          mode='multiple'
          placeholder='Any status'
          allowClear
          maxTagCount='responsive'
          value={draft.statuses}
          options={INTEGRATION_STATUS_OPTIONS}
          onChange={(statuses: IntegrationStatus[]) =>
            setDraft((current) => ({ ...current, statuses: statuses ?? [] }))
          }
          style={{ width: '100%' }}
        />
      </Vertical>

      <Vertical gap={4}>
        <SectionLabel>State</SectionLabel>
        <Select
          mode='multiple'
          placeholder='Any state'
          allowClear
          maxTagCount='responsive'
          value={draft.progressionStates}
          options={PROGRESSION_STATE_OPTIONS}
          onChange={(progressionStates: OrderProgressionState[]) =>
            setDraft((current) => ({
              ...current,
              progressionStates: progressionStates ?? [],
            }))
          }
          style={{ width: '100%' }}
        />
      </Vertical>

      <Vertical gap={4}>
        <SectionLabel>Partners</SectionLabel>
        <Select
          mode='multiple'
          placeholder='Any partner'
          allowClear
          maxTagCount='responsive'
          value={draft.partnerTenantIds}
          options={partnerOptions}
          onChange={(partnerTenantIds: string[]) =>
            setDraft((current) => ({
              ...current,
              partnerTenantIds: partnerTenantIds ?? [],
            }))
          }
          style={{ width: '100%' }}
        />
      </Vertical>
    </FiltersPopover>
  )
}
